import { FlatfileClient } from "@flatfile/api";
import { BATCH_LABELS_WS_KEYS } from "@wingspanhq/payments/dist/lib/constants";
import { Batch } from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";

/**
 * Flatfile API client authenticated with the space access token the listener
 * stored on the batch metadata.
 *
 * Returns undefined for batches without a Flatfile space (API uploads) or when
 * the space access token is not available (yet).
 */
export function useFlatfileApiClient(
  batch?: Batch
): FlatfileClient | undefined {
  const accessToken =
    batch?.metadata?.[BATCH_LABELS_WS_KEYS.flatfileAccessToken];

  return useMemo(
    () =>
      accessToken ? new FlatfileClient({ token: accessToken }) : undefined,
    [accessToken]
  );
}
